import StopsParking from './StopsParking';
import Rides from './Rides';
import ObjectEvents from './ObjectEvents';
import Offline from './Offline';
import TotalMileage from './TotalMileage';
import GeofencesCrossing from './GeofencesCrossing';
import GeofenceVisits from './GeofenceVisits';
import ShiftMileage from './ShiftMileage';
import SeparateMileage from './SeparateMileage';
import AverageMileage from './AverageMileage';
import Kdm from './Kdm';
import VehicleMileage from './VehicleMileage';
import Fuel from './Fuel';
import FuelCAN from './FuelCAN';
import FuelTankerFillings from './FuelTankerFillings';
import KdmArctic from './KdmArctic';
import VehicleIdles from './VehicleIdles';
import ProcessedArea from './ProcessedArea';
import EngineHours from './EngineHours';
import RidesInGeofences from './RidesInGeofences';
import Trips from './Trips';
import MileageFuel from './MileageFuel';
import EngineHoursGrouped from './EngineHoursGrouped';
import FuelControl from './FuelControl';
import GeofencesVisitAnalysis from './GeofencesVisitAnalysis';
import KdmStrewing from './KdmStrewing';
import CustomSensors from './CustomSensors';
import Overspeed from './Overspeed';
import Debug from './Debug';
import FuelAnalysis from './FuelAnalysis';
import ControlWorkTime from './ControlWorkTime';
import CompetitionViolations from './CompetitionViolations';
import Temperature from './Temperature';
import FuelMultiple from './FuelMultiple.vue';
import ChosenDataReport from './ChosenDataReport.vue';
import TemperatureIqFreeze from './TemperatureIqFreeze.vue';
import PassengerTransportation from './PassengerTransportation.vue';
import NormConsumption from './NormConsumption.vue';

export default {
  1: StopsParking,
  2: Rides,
  3: ObjectEvents,
  4: Offline,
  5: TotalMileage,
  6: GeofencesCrossing,
  7: GeofenceVisits,
  8: ShiftMileage,
  9: SeparateMileage,
  10: AverageMileage,
  11: Kdm,
  12: VehicleMileage,
  13: Fuel,
  14: VehicleIdles,
  15: FuelTankerFillings,
  16: FuelCAN,
  17: Offline,
  18: KdmArctic,
  19: ObjectEvents,
  20: GeofencesVisitAnalysis,
  21: Temperature,
  22: ProcessedArea,
  23: EngineHours,
  24: PassengerTransportation,
  25: RidesInGeofences,
  26: Trips,
  27: MileageFuel,
  28: EngineHoursGrouped,
  29: FuelControl,
  30: KdmStrewing,
  33: CustomSensors, // todo: add 31 & 32 reports
  34: Overspeed,
  35: Debug,
  36: FuelAnalysis,
  37: ControlWorkTime,
  38: CompetitionViolations,
  39: FuelMultiple,
  40: ChosenDataReport,
  41: TemperatureIqFreeze,
  42: TemperatureIqFreeze,
  44: NormConsumption,
};

// Все пробелы и переносы строк будут отображаться из-за white-space: pre-wrap. Для структуризации абзацев рекомендуется добавлять пробелы в начале каждой строки (text-intent не поддерживает отступы для перенесенных строк)
export const ReportInfos = {
  15:
`        Предназначен для определения количества топлива и техники, которой было отпущено топливо. Для выбора объекта при формировании отчёта отбираются объекты с наличием датчиков "Дут импульсный" или "ДУТ импульсный накопительный".
        Также обязательным является наличие датчика с именем touch_key.
        Количество топлива, которое было отпущено определяется по датчикам ДУТов.
        Интервалы, в которых производился отпуск топлива определяются по двум алгоритмам:

        Алгоритм №1 (у объекта имеется дополнительный параметр GetEventsFromTouchKey=1)
        -    Начало интервала определяется по наличию значения в датчике touch_key или наличию 1 в датчике типа клапан
        -    Окончание интервала определяется по наличию значения 0, либо в датчике touch_key, либо датчике типа клапан
        -    Если у объекта имеется датчик типа клапан, и происходит рост значений в одном из ДУТов при в клапане значение 0, то такое событие будет считаться дребезгом датчика, и не будет зафиксировано как выдача топлива.

        Алгоритм №2 (у объекта отсутствует дополнительный параметр GetEventsFromTouchKey либо он равен 0)
        -    Если у объекта есть датчик с типом "Клапан", то производится фильтрация сообщений, остаются только сообщения со значениями датчиков ДУТов, у которых "Клапан"=1.
        -    Для определения интервалов выбираются периоды, когда изменялись значения отфильтрованных ДУТов, не превышающие по времени значение параметра FuelTankEventsTimeMinutes; также скорость изменения значений топлива должна быть больше чем указано в параметре FuelTankMinFillSpeed
`,
  39:
`        Предназначен для анализа состояния количества топлива в заправочных ёмкостях топливозаправщиков.
        Для построения отчёта у объекта должен иметься как минимум один датчик типа "дут в секции атз", в противном случае будет возвращена ошибка выполнения отчёта.
        Если у объекта 2 и более таких датчиков, то в отчёт попадут данные отдельно по каждому из ДУТов, а также их сумма. Для каждого ДУТа выводится два показателя: точное значение и усреднённое по соседним сообщениям (для сглаживания колебаний)
        Как и в топливном отчёте, отображением каждого показателя можно управлять, включая или исключая его из отображения на графике. По умолчанию отображение всех показателей включено.
        По каждому ДУТу формируется таблица сводки, в которой отображаются данные с группировкой по датам.`,
};
